<template>
    <footer
        class="md-footer layout2"
        :class="[{ inner: inner }]"
        :style="{
            ...colorStyle,
            ...spaceStyle,
            backgroundColor: bgColor
        }"
    >
        <div class="footer-container" :style="{ color: fontColor }">
            <div class="top-content">
                <div class="top-inner" :class="{ 'f-col': !inner }">
                    <MlsDisclaimer
                        v-if="!wordPressSSR"
                        theme="layout2"
                        @update="mlsUpdated"
                    />

                    <div class="no-mls-disclaimer texas-mls" v-if="hasTeaxsMls">
                        <a
                            href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                            target="_blank"
                            :title="$t('md-footer.realEstateConsumer')"
                            rel="noopener noreferrer"
                        >{{ $t('md-footer.realEstateConsumer') }}</a>
                    </div>
                    <div
                        class="no-mls-disclaimer"
                        v-if="noMlsDisclaimers.length > 0"
                    >
                        <div
                            class="claimer"
                            v-for="(noMls, index) in noMlsDisclaimers"
                            :key="index"
                            v-html="noMls.label"
                        ></div>
                    </div>
                </div>
            </div>
            <div
                class="bottom-content"
                :style="{ backgroundColor: botBgColor }"
            >
                <div class="bottom-inner" :class="{ 'f-col': !inner }">
                    <div class="flex-box">
                        <div class="agent-logo">
                            <div class="logo-wrap">
                                <div class="site-logo" v-if="logos.length > 0">
                                    <template
                                        v-for="(logo, index) in validLogos"
                                    >
                                        <a
                                            v-if="logo.logo.href"
                                            :key="index"
                                            :href="logo.logo.href"
                                            aria-label="site logo"
                                            rel="noopener noreferrer"
                                        >
                                            <site-img
                                                class="logo-item"
                                                :src="logo.logo"
                                                alt="site logo"
                                                :style="{
                                                    height: size / 100 + 'em'
                                                }"
                                                :ssrInitSize="30"
                                                dir="height"
                                            />
                                        </a>
                                        <site-img
                                            v-else
                                            class="logo-item"
                                            :key="'key-' + index"
                                            :src="logo.logo"
                                            alt="site logo"
                                            :style="{
                                                height: size / 100 + 'em'
                                            }"
                                            :ssrInitSize="30"
                                            dir="height"
                                        />
                                    </template>
                                </div>
                            </div>
                            <div
                                v-if="socialNetworksInfo.length > 0"
                                class="share-links"
                            >
                                <a
                                    v-for="(
                                        social, index
                                    ) in socialNetworksInfo"
                                    :key="social.id + '-' + index"
                                    class="share-item"
                                    :href="social.url"
                                    :aria-label="social.socialNetwork"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i
                                        class="iconfont"
                                        :class="social.icon"
                                    ></i>
                                </a>
                            </div>
                            <div class="agent-wrap">
                                <div
                                    v-if="companyInfo?.name"
                                    class="co-name"
                                    :style="footerBroNameStyle"
                                    v-html="companyInfo.name"
                                ></div>
                                <div class="agent-detail">
                                    <div
                                        v-if="
                                            footerAgentInfo?.firstName ||
                                                footerAgentInfo?.lastName
                                        "
                                        class="agent-name"
                                        :style="footerAgentInfoStyle"
                                    >
                                        {{ footerAgentInfo.firstName || '' }}
                                        {{ footerAgentInfo.lastName || '' }}
                                    </div>
                                    <div class="agent-info">
                                        <div
                                            class="phone-email"
                                            v-if="
                                                footerAgentInfo?.phone ||
                                                    footerAgentInfo?.email
                                            "
                                        >
                                            <div
                                                v-if="footerAgentInfo?.phone"
                                                class="detail-phone agent-item"
                                                :style="footerAgentInfoStyle"
                                            >
                                                <a
                                                    :href="
                                                        'tel:' +
                                                            footerAgentInfo.phone
                                                    "
                                                    target="_top"
                                                    rel="noopener noreferrer"
                                                >
                                                    <!-- <i
                                                    class="iconfont icon-phone1"
                                                ></i> -->
                                                    <span class="text">
                                                        {{
                                                            $ft.formatPhone(
                                                                footerAgentInfo.phone
                                                            )
                                                        }}
                                                    </span>
                                                </a>
                                            </div>
                                            <div
                                                v-if="footerAgentInfo?.email"
                                                class="detail-email agent-item"
                                                :style="footerAgentInfoStyle"
                                            >
                                                <a
                                                    :href="
                                                        'mailto:' +
                                                            footerAgentInfo.email
                                                    "
                                                    rel="noopener noreferrer"
                                                >
                                                    <!-- <i
                                                    class="iconfont icon-v5-email"
                                                ></i> -->
                                                    <span class="text">
                                                        {{
                                                            footerAgentInfo.email
                                                        }}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            v-if="getAddressInfo"
                                            class="detail-addr agent-item"
                                            :style="footerBroAddrStyle"
                                        >
                                            <!-- <i
                                                class="iconfont icon-address1"
                                            ></i> -->
                                            <span
                                                class="text"
                                                v-html="getAddressInfo"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <closely-app-download
                                useModule="md-footer"
                                :downloadTheme="true"
                            />
                        </div>
                        <ul class="menu-wrap main-menu" v-if="!isMobile">
                            <li class="first-col">
                                <menu-item
                                    v-for="(menu, index) in firstMenus"
                                    :key="'firstMenu-' + index"
                                    :selfKey="'firstMenu-' + index"
                                    :expandKey="expandKey"
                                    :menu="menu"
                                    :useMenuStyle="footerMenuStyle"
                                    :useSubMenuStyle="footerSubMenuStyle"
                                    @updateExpandKey="updateExpandKey"
                                />
                            </li>
                            <li class="second-col">
                                <menu-item
                                    v-for="(menu, index) in secondMenus"
                                    :key="'secondMenu-' + index"
                                    :selfKey="'secondMenu-' + index"
                                    :expandKey="expandKey"
                                    :menu="menu"
                                    :useMenuStyle="footerMenuStyle"
                                    :useSubMenuStyle="footerSubMenuStyle"
                                    @updateExpandKey="updateExpandKey"
                                />
                            </li>
                            <li class="third-col">
                                <menu-item
                                    v-for="(menu, index) in thirdMenus"
                                    :key="'thirdMenu-' + index"
                                    :selfKey="'thirdMenu-' + index"
                                    :expandKey="expandKey"
                                    :menu="menu"
                                    :useMenuStyle="footerMenuStyle"
                                    :useSubMenuStyle="footerSubMenuStyle"
                                    @updateExpandKey="updateExpandKey"
                                />
                            </li>
                        </ul>
                    </div>
                    <div
                        class="detail-wrap"
                        v-if="
                            subOwnerInfo ||
                                footerAgentCustomContent ||
                                agentHasDisclaimer ||
                                subOwnerHasDisclaimer
                        "
                    >
                        <div
                            class="detail subdomain-detail"
                            v-if="subOwnerInfo"
                        >
                            <p
                                class="detail-info subinfo-name"
                                v-if="subOwnerName"
                            >
                                <span v-text="subOwnerName" class="detail-name">
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="subOwnerInfo?.phone"
                                    class="detail-phone"
                                >
                                    <a
                                        :href="'tel:' + subOwnerInfo.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        {{
                                            $ft.formatPhone(subOwnerInfo.phone)
                                        }}
                                    </a>
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="subOwnerInfo?.email"
                                    class="detail-email"
                                >
                                    <a
                                        :href="'mailto:' + subOwnerInfo.email"
                                        rel="noopener noreferrer"
                                    >
                                        {{ subOwnerInfo.email }}
                                    </a>
                                </span>
                            </p>
                        </div>

                        <div
                            class="detail other-cont"
                            v-if="footerAgentCustomContent"
                        >
                            <div
                                class="custom-content"
                                v-html="
                                    formatFontSize(footerAgentCustomContent)
                                "
                            ></div>
                        </div>
                        <div
                            class="detail-info"
                            v-if="agentHasDisclaimer || subOwnerHasDisclaimer"
                        >
                            <template v-if="agentHasDisclaimer">
                                <p
                                    v-for="(
                                        file, index
                                    ) in footerAgentInfo.disclaimerList"
                                    :key="index + 'mainfile'"
                                    class="detail-file"
                                >
                                    <a
                                        :href="file.url"
                                        rel="noopener noreferrer"
                                    >
                                        {{ file.name.split('.')[0] }}
                                    </a>
                                </p>
                            </template>
                            <!-- sub file -->
                            <template v-if="subOwnerHasDisclaimer">
                                <p
                                    v-for="(
                                        file, index
                                    ) in subOwnerInfo.disclaimerList"
                                    :key="index + 'subfile'"
                                    class="detail-file"
                                >
                                    <a
                                        :href="file.url"
                                        rel="noopener noreferrer"
                                    >
                                        {{ file.name.split('.')[0] }}
                                    </a>
                                </p>
                            </template>
                        </div>
                    </div>
                    <a class="md-footer_notshare" v-if="isDoNotShareShow" href="/site/dsar">{{ $t('md-footer.doNotShare') }} --&gt; </a>
                    <div v-if="!hideCopyRight" class="copyright">
                        <template v-if="gfFlag != '1'">
                            <p
                                class="cr"
                                v-if="showCopyright"
                                v-html="
                                    $t('md-footer.madeInAndCopyright', {
                                        chimeLink,
                                        year
                                    })
                                "
                            ></p>
                            <p class="ppt">
                                <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                            </p>
                        </template>
                        <p v-else class="cr">
                            {{ $t('md-footer.geographicFarmingLlc', { year }) }}
                            <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import common from '../index-layout';
export default {
    mixins: [common],
    data: function() {
        return {};
    },
    computed: {
        firstMenus() {
            return this.z_menus.filter((item, index) => index % 3 === 0);
        },
        secondMenus() {
            return this.z_menus.filter((item, index) => index % 3 === 1);
        },
        thirdMenus() {
            return this.z_menus.filter((item, index) => index % 3 === 2);
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '../index.scss';

.md-footer.layout2 {
    color: var(--g-primary-color);

    &.fixed {
        position: fixed;
        bottom: 0;
        width: 100%;
    }
    .footer-container {
        position: relative;
    }
    .top-content {
        padding: 50px 0;

        .mls-declaimer-container-v2 {
            padding-top: 0;
            color: var(--g-text-color);
            .declaimer {
                display: flex;
                flex-direction: column-reverse;
                gap: 15px;
                align-items: flex-start;
                .content {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    color: var(--g-text-color);
                }
                .mls-logo {
                    margin-top: 0;
                }
            }
        }
        .no-mls-disclaimer {
            margin-top: 20px;
            color: var(--g-text-color);
            .claimer + .claimer {
                margin-top: 15px;
                p {
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 20px;
                    text-align: left;
                    color: var(--g-text-color);
                }
            }
        }
    }
    .bottom-content {
        background: rgba(25, 25, 25, 1);
        padding: 50px 0;
        .flex-box {
            display: flex;
            gap: 180px;
            justify-content: space-between;
            align-items: flex-start;
        }
        .agent-logo {
            width: 40%;
            .logo-wrap {
                .site-logo {
                    font-size: 50px;
                    overflow: hidden;
                    position: relative;
                    display: flex;
                    flex-wrap: wrap;
                    gap: 40px;
                    .logo-item {
                        height: 1em;
                    }
                }
            }

            .share-links {
                margin-top: 30px;
                font-size: 0px; // remove inline-block spacing
                display: flex;
                flex-wrap: wrap;
                gap: 15px;

                .share-item {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    border: 1px solid var(--g-primary-color);
                    .iconfont {
                        font-size: 14px;
                        color: var(--g-primary-color);
                    }
                    &:hover {
                        border: 1px solid #fff;
                        background: #fff;
                        .iconfont {
                            color: var(--bg-color);
                        }
                    }
                }
            }

            .agent-wrap {
                margin-top: 50px;
                display: flex;
                flex-direction: column;
                gap: 20px;
                .co-name,
                .agent-name {
                    font-family: var(--mg-title-font);
                    font-size: 18px;
                    line-height: 27px;
                    text-align: left;
                }

                .phone-email {
                    display: flex;
                    flex-wrap: wrap;
                    column-gap: 20px;
                }

                .agent-detail {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .agent-info {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;

                    .agent-item {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 21px;
                        text-align: left;

                        &.detail-phone,
                        &.detail-email {
                            position: relative;
                            &:before {
                                content: ' ';
                                position: absolute;
                                left: 0%;
                                right: unset;
                                bottom: 2px;
                                top: unset;
                                height: 1px;
                                width: 0%;
                                background-color: var(--g-primary-color);
                                -webkit-transition: width 0.3s ease;
                                transition: width 0.3s ease;
                            }
                            &:hover:before {
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }
        .detail-wrap {
            margin-top: 40px;
            .detail {
                &.subdomain-detail,
                &.other-cont {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 21px;
                    text-align: left;
                }
                &.subdomain-detail {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    > span {
                        vertical-align: top;
                    }
                }
                &.other-cont {
                    margin-top: 20px;
                }
            }

            > .detail-info {
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .detail-file {
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 21px;
                    text-align: left;
                    opacity: 0.5;
                }
            }

            @include no-mls-disclaimer;
        }
        .main-menu {
            flex: 1;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: flex-start;

            .first-col,
            .second-col,
            .third-col {
                width: 33.3%;
                display: flex;
                flex-direction: column;
                gap: 20px;

                .menu-item {
                    cursor: pointer;
                    display: block;
                    padding-left: 0;

                    & > a {
                        display: flex;
                        align-items: center;
                        position: relative;
                        max-width: 100%;
                        @include ellipsis();
                    }

                    .footer-menu {
                        line-height: 1.5;
                        cursor: pointer;
                        font-weight: 700;

                        .icon-arrow-down {
                            font-size: inherit;
                            position: relative;
                            left: 10px;
                            display: inline-block;
                            transform: scale(0.7, 0.8);
                        }

                        &.down .icon-arrow-down {
                            transform: rotate(180deg) scale(0.7, 0.8);
                        }
                    }

                    .footer-submenu {
                        margin-top: 10px;
                        .sub-menu {
                            margin-bottom: 0;
                            display: block;
                            opacity: 0.8;

                            & > a {
                                display: inline-block;
                                position: relative;
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 2.15;
                                &:before {
                                    content: ' ';
                                    position: absolute;
                                    left: 0%;
                                    right: unset;
                                    bottom: 2px;
                                    top: unset;
                                    height: 1px;
                                    width: 0%;
                                    background-color: var(--g-primary-color);
                                    -webkit-transition: width 0.3s ease;
                                    transition: width 0.3s ease;
                                }
                                &:hover:before {
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }
        }

        .download-closely {
            margin-top: 40px;
            display: flex;
            flex-direction: column-reverse;
            gap: 10px;
            .code-title {
                font-size: 12px;
                font-weight: 400;
                line-height: 21px;
                text-align: left;
                margin-bottom: 0;
                color: var(--g-primary-color);
            }
            .code-wrapper {
                .android {
                    margin-left: 30px;
                }

                .android,
                .ios {
                    img {
                        width: 80px;
                        height: 80px;
                    }
                }

                justify-content: flex-start;
            }
        }

        .copyright {
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            text-align: left;
            color: var(--g-primary-color);
            opacity: 0.5;
            position: relative;
            padding-top: 81px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &:before {
                content: '';
                width: 100%;
                height: 1px;
                background: rgba(218, 218, 218, 0.5);
                margin: 40px 0;
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
            }

            .cr,
            .ppt {
                line-height: 20px;
                a {
                    text-decoration: underline;
                    white-space: nowrap;
                }
            }
        }
    }

    &.inner {
        .top-content {
            padding: 50px var(--inner-padding, 20px);
        }
        .bottom-content {
            padding: 50px var(--inner-padding, 20px);
            .flex-box {
                flex-direction: column;
                gap: 40px;
            }
            .agent-logo {
                width: 100%;
            }
            .main-menu {
                flex: none;
                width: 100%;
            }
            .download-closely {
                .code-title {
                    text-align: left;
                }
            }
        }
    }

    .fair-house-logo {
        vertical-align: text-bottom;
        margin: 0 5px;
        padding-top: 5px;
    }

    @mixin media-600-footer {
        .bottom-content {
            padding: 40px 0;
            .flex-box {
                flex-direction: column;
                gap: 40px;
            }
            .agent-logo {
                width: 100%;
                .logo-wrap {
                    .site-logo {
                        gap: 20px;
                    }
                }

                .share-links {
                    margin-top: 25px;
                    gap: 10px;
                    .share-item {
                        width: 30px;
                        height: 30px;
                        .iconfont {
                            font-size: 12px;
                        }
                    }
                }
                .agent-wrap {
                    margin-top: 25px;
                }
            }

            .copyright {
                flex-direction: column;
                gap: 15px;
                padding-top: 41px;
                &:before {
                    margin: 20px 0;
                }
            }
            .download-closely {
                margin-top: 20px;
                justify-content: flex-start;
                flex-direction: column;
                .code-title {
                    line-height: 18px;
                    text-align: left;
                }
            }
        }

        .top-content {
            padding: 40px 0;
        }
    }

    @include media-600 {
        @include media-600-footer();
    }
}
</style>
